import { createContext } from "react";

import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { Groups, Permissions } from "../types/permissions";

type PermissionsContextType = {
  permissions: Permissions;
  setPermissions: React.Dispatch<React.SetStateAction<Permissions>>;
  hasPermissions: (actionsList: ActionType[]) => boolean;
  groups: Groups;
  hasGroups: (groupNames: string[]) => boolean;
};

export const PermissionsContext = createContext<PermissionsContextType>(
  {} as PermissionsContextType,
);
